/**
 * lazy-video.js
 * Defers loading/playing background <video data-lazy-video> elements until they
 * enter the viewport, then pauses them when they leave. Videos must be muted +
 * playsinline so programmatic play() is allowed without a user gesture.
 *
 * Pair with: <video data-lazy-video muted loop playsinline preload="none" poster="...">
 * Idempotent + safe to include from multiple sections.
 */
(function () {
  function playVideo(v) {
    if (v.preload === "none") {
      v.preload = "auto";
      v.load();
    }
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  // No IntersectionObserver support: just play everything (graceful fallback).
  if (!("IntersectionObserver" in window)) {
    document.querySelectorAll("video[data-lazy-video]").forEach(playVideo);
    return;
  }

  // One shared observer across all sections.
  var io =
    window.__lazyVideoIO ||
    (window.__lazyVideoIO = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            playVideo(v);
          } else if (!v.paused) {
            v.pause();
          }
        });
      },
      { rootMargin: "200px 0px", threshold: 0.1 },
    ));

  function init(root) {
    (root || document)
      .querySelectorAll("video[data-lazy-video]:not([data-lazy-bound])")
      .forEach(function (v) {
        v.setAttribute("data-lazy-bound", "1");
        io.observe(v);
      });
  }

  if (document.readyState !== "loading") init();
  else
    document.addEventListener("DOMContentLoaded", function () {
      init();
    });

  // Re-bind videos injected by the theme editor on section reload.
  document.addEventListener("shopify:section:load", function (e) {
    init(e.target);
  });
})();
